import { T2dNavItem } from '@tec2date/ui-components';

/**
 * Sidebar-Navigation: nur die produktiven Top-Level-Bereiche.
 *
 * Die Administration (Sys-/Org-Einstellungen), persönliche Items
 * (Mein Profil, Meine Einladungen) und der Mandant-Switcher liegen
 * im User-Menü der T2dAppShell — siehe `DefaultLayoutComponent.userMenuItems`.
 */
export const navItems: T2dNavItem[] = [
  { label: 'Dashboard', route: '/dashboard' },
  { label: 'Projekte', route: '/projekte' },
  { label: 'Organisationen', route: '/organisationen' },
  { label: 'Ansprechpartner', route: '/ansprechpartner' },
  { label: 'Dokumente', route: '/dokumente' },
  { label: 'KI-Team', route: '/ki-team' },
  {
    label: 'Werkzeuge',
    children: [{ label: 'NHK-Rechner', route: '/werkzeuge/nhk-rechner' }],
  },
];
